import React from 'react';
import PropTypes from 'prop-types';

const SubmitButton = ({
  isSubmitting,
  label,
  submittingLabel,
  onClick,
  disabled,
  className,
}) => (
  <>
    <button
      type="submit"
      className={`button ${className} ${
        isSubmitting || disabled ? ' button--disabled' : ''
      }`}
      disabled={isSubmitting || disabled}
      onClick={onClick}
    >
      {isSubmitting ? submittingLabel : label}
    </button>
    <style jsx>{`
      font-family: 'Roboto-Medium';
      font-size: 13px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: center;
    `}</style>
  </>
);

SubmitButton.propTypes = {
  isSubmitting: PropTypes.bool,
  label: PropTypes.string.isRequired,
  submittingLabel: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

SubmitButton.defaultProps = {
  onClick: undefined,
  disabled: false,
  className: 'button--submit',
  submittingLabel: '',
  isSubmitting: false,
};

export default SubmitButton;
